import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  variant?: 'default' | 'compact' | 'large';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  if (variant === 'large') {
    return (
      <Link
        to={`/article/${comic.id}`}
        className="block group cursor-pointer"
      >
        <div className="bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1">
          <div className="relative aspect-[3/4] overflow-hidden">
            <img
              src={comic.coverImage}
              alt={comic.title}
              title={`${comic.title} - 虚空韩漫网`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute top-3 left-3">
              <span className={`px-2 py-1 rounded-md text-xs font-medium ${
                comic.status === '已完结'
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-primary-500 text-background-50'
              }`}>
                {comic.status}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
              <span className="text-background-50 text-xs font-medium">
                {comic.views >= 10000
                  ? `${(comic.views / 10000).toFixed(1)}万人看过`
                  : `${comic.views}人看过`}
              </span>
            </div>
          </div>
          <div className="p-4">
            <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
              {comic.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
            <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
              {comic.description}
            </p>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${comic.id}`}
        className="block group cursor-pointer"
      >
        <div className="bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1">
          <div className="aspect-[3/4] overflow-hidden">
            <img
              src={comic.coverImage}
              alt={comic.title}
              title={`${comic.title} - 虚空韩漫网`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
          </div>
          <div className="p-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
              {comic.title}
            </h4>
            <p className="mt-1 text-xs text-foreground-500">
              更新于 {comic.updateDate}
            </p>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${comic.id}`}
      className="block group cursor-pointer"
    >
      <div className="bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 hover:-translate-y-1">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={comic.coverImage}
            alt={comic.title}
            title={`${comic.title} - 虚空韩漫网`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <span className={`px-2 py-1 rounded-md text-xs font-medium ${
              comic.status === '已完结'
                ? 'bg-accent-500 text-background-50'
                : 'bg-primary-500 text-background-50'
            }`}>
              {comic.status}
            </span>
          </div>
        </div>
        <div className="p-4">
          <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {comic.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
          <div className="flex items-center gap-2 mt-2">
            <span className="flex items-center gap-1 text-xs text-accent-500">
              <i className="ri-star-fill text-xs"></i>
              {comic.rating}
            </span>
            <span className="text-xs text-foreground-400">
              {comic.views >= 10000
                ? `${(comic.views / 10000).toFixed(1)}万`
                : comic.views}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}